import request from '@/utils/request'

export function assignNotification() {
  return
}

export function getUserGroups() {
  return request({
    url: '/config-service/v1/user-group-notification/user-groups',
    method: 'get'
  })
}

export function getDiagram() {
  return request({
    url: '/config-service/v1/user-group-notification/diagram',
    method: 'get'
  })
}

export function getFunctions() {
  return request({
    url: '/config-service/v1/user-group-notification/function',
    method: 'get'
  })
}

export function updateDiagram(payload) {
  return request({
    url: '/config-service/v1/user-group-notification/assign',
    method: 'put',
    data: payload
  })
}

export function getUserGroupNotificationListApi(query) {
  return request({
    url: '/config-service/v1/user-group-notification',
    method: 'get',
    params: query
  })
}
